export enum FeeKind {
  Fixed = 'fixed',
  Percent = 'percent'
}
